import React, { useState } from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { useGetEventProducts } from 'api/queries/events/products';
import { useEventEditorContext } from 'legacy/events/contexts/EventEditorContext';
import TierList from './components/TierList';
import { OutgoingEventProductDto } from 'api/dtos/events/products';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import { PromoterOfferTier } from '../TierSelection';

const TierSelectionModal = ({
  onClose,
  onSubmit,
  tiers
}: {
  tiers: PromoterOfferTier[];
  onClose: () => void;
  onSubmit: (tiers: PromoterOfferTier[]) => void;
}) => {
  const [selectedTiers, setSelectedTiers] =
    useState<PromoterOfferTier[]>(tiers);
  const { eventId } = useEventEditorContext();
  const { data: productsData, isLoading: isLoadingProducts } =
    useGetEventProducts({
      eventId
    });
  const handleSubmit = () => {
    onSubmit(selectedTiers);
  };

  const footerText = `Add Eligible Tiers ${
    selectedTiers.length > 0 ? `• ${selectedTiers.length}` : ''
  }`;

  const handleSelectTier = (tier: OutgoingEventProductDto) => {
    const newSelectedTierIds = selectedTiers.some((t) => t.id === tier.id)
      ? selectedTiers.filter((t) => t.id !== tier.id)
      : [...selectedTiers, tier];
    setSelectedTiers(newSelectedTierIds);
  };

  return (
    <Modal
      visible
      autoHeight
      type={ModalType.SMALL}
      onClose={onClose}
      shouldStopModalClose={false}
      title="Select a Ticket Tiers"
      icon={<IoMdArrowBack size={20} color="#000" />}
      renderFooter={() => (
        <Button
          type={ButtonType.Primary}
          onClick={handleSubmit}
          loading={false}
        >
          {footerText}
        </Button>
      )}
    >
      <div className="px-4 flex flex-col justify-between">
        <div>
          {isLoadingProducts ? (
            <div className="h-[30vh] flex flex-col items-center justify-center mt-6">
              <Spinner type={SpinnerType.PRIMARY} />
            </div>
          ) : (
            <div className="overflow-y-auto mt-4">
              <TierList
                isLoading={isLoadingProducts}
                items={productsData?.items || []}
                onSelect={handleSelectTier}
                selectedItems={selectedTiers}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TierSelectionModal;
